import React from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

/**
 * Small 3-position theme toggle (light / system / dark).
 * Designed to slot into the Navbar's icon row.
 */
export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const options = [
    { key: "light", icon: Sun, label: "Light" },
    { key: "system", icon: Monitor, label: "System" },
    { key: "dark", icon: Moon, label: "Dark" },
  ];

  return (
    <div
      role="group"
      aria-label="Theme"
      data-testid="theme-toggle"
      className="inline-flex items-center bg-[#EAE6E1]/50 dark:bg-[#2C302E]/60 rounded-full p-0.5 gap-0.5"
    >
      {options.map(({ key, icon: Icon, label }) => {
        const active = theme === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => setTheme(key)}
            data-testid={`theme-toggle-${key}`}
            title={label}
            aria-label={`Switch to ${label.toLowerCase()} theme`}
            aria-pressed={active}
            className={`no-touch-min p-1.5 rounded-full transition-soft ${
              active
                ? "bg-white dark:bg-[#1F2421] text-[#2A2F2B] dark:text-[#E8E6E2] shadow-sm"
                : "text-[#6B7068] hover:text-[#2A2F2B] dark:hover:text-[#E8E6E2]"
            }`}
          >
            <Icon className="w-3.5 h-3.5" strokeWidth={1.75} />
          </button>
        );
      })}
    </div>
  );
}
